import { html } from "htm/preact";
import { useState } from "preact/hooks";

import { InnerContainer } from "../inner-container";
import { UnderlineLink } from "../underline-link";

export const SlidesSection = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const mapping = {
    0: {
      title: "Eat",
      icon:
        "https://www.uber-assets.com/image/upload/v1542256606/assets/7d/5a4852-3b2a-4466-96de-602dfb62dc1b/original/restaurant-outlined.svg",
      background:
        "https://www.uber-assets.com/image/upload/f_auto,q_auto:eco,c_fill,g_center,w_1904,h_901/v1584996282/assets/0b/df0e6a-83a1-4921-88da-a2568701de01/original/eats-hero-desktop-5.jpg",
      content: html`<${EatContent} />`,
    },
    1: {
      title: "Ride",
      icon:
        "https://www.uber-assets.com/image/upload/v1542252540/assets/6d/87af17-3970-4d01-8936-1b0ba102ea6e/original/car-front-outlined.svg",
      background:
        "https://www.uber-assets.com/image/upload/f_auto,q_auto:eco,c_fill,g_center,w_1258,h_761/v1558484011/assets/fb/fc9790-bb1c-427c-8504-684ae1def5e8/original/ride_2x.jpg",
      content: html`<${RideContent} />`,
    },
    2: {
      title: "Earn",
      icon:
        "https://www.uber-assets.com/image/upload/v1558389718/assets/8e/33c8c0-f7e9-467c-924b-c70232943a47/original/Earn-filled.svg",
      background:
        "https://www.uber-assets.com/image/upload/f_auto,q_auto:eco,c_fill,g_center,w_1258,h_761/v1578357180/assets/69/908bc0-7167-40d0-b046-af52170801f5/original/Product-Masthead-Desktop_2.jpg",
      content: html`<${EarnContent} />`,
    },
    3: {
      title: "Freight",
      icon:
        "https://www.uber-assets.com/image/upload/v1542257500/assets/14/aa5c19-33cc-4556-a8e3-8228253af608/original/truck-outlined.svg",
      background:
        "https://www.uber-assets.com/image/upload/f_auto,q_auto:eco,c_fill,g_center,w_1258,h_761/v1558484117/assets/8a/fa8125-145d-4b00-b916-0ee7041f826e/original/Freight_2x.jpg",
      content: html`<${FreightContent} />`,
    },
    4: {
      title: "Business",
      icon:
        "https://www.uber-assets.com/image/upload/v1542252354/assets/e3/24ab47-806e-493b-9df8-748763238cc8/original/briefcase-outlined.svg",
      background:
        "https://www.uber-assets.com/image/upload/f_auto,q_auto:eco,c_fill,g_center,w_1258,h_761/v1558484175/assets/4d/9ea561-e479-440f-b79a-c56b0dc2e3d2/original/Business_2x.jpg",
      content: html`<${BusinessContent} />`,
    },
    5: {
      title: "Transit",
      icon:
        "https://www.uber-assets.com/image/upload/v1542257396/assets/18/30d860-25cc-4113-b155-8ee863a3efa3/original/train-outlined.svg",
      background:
        "https://www.uber-assets.com/image/upload/f_auto,q_auto:eco,c_fill,g_center,w_1258,h_761/v1558484214/assets/f7/a6b0dc-065d-4916-ba1f-9b788fd2997d/original/Transit_2x.jpg",
      content: html`<${TransitContent} />`,
    },
    6: {
      title: "Bike & scoot",
      icon:
        "https://www.uber-assets.com/image/upload/v1542252195/assets/69/e1d56d-4b83-4878-aab5-c37ea291e188/original/bike-outlined.svg",
      background:
        "https://www.uber-assets.com/image/upload/f_auto,q_auto:eco,c_fill,g_center,w_1258,h_761/v1558484252/assets/70/5af028-9661-4f3f-97cf-e80e32d2d225/original/bikes_2x.jpg",
      content: html`<${BikeContent} />`,
    },
    7: {
      title: "Elevate",
      icon:
        "https://www.uber-assets.com/image/upload/v1573109528/assets/7b/1cae91-fbf4-4e3e-9537-006b4a0dc3bc/original/copter_outlined.svg",
      background:
        "https://www.uber-assets.com/image/upload/f_auto,q_auto:eco,c_fill,g_center,w_1258,h_761/v1558484293/assets/4e/f3c1d1-0eb6-4d01-9d18-38ab2e43b997/original/Fly_2x.jpg",
      content: html`<${ElevateContent} />`,
    },
  };
  return html`
    <div className="slides-section z-10 relative">
      <${InnerContainer} hasPaddingSmall="${false}" className="z-10 relative">
        <div className="flex items-start lg:grid lg:grid-cols-8 shadow w-full relative overflow-x-auto">
          ${Object.entries(mapping).map(
            ([index, data]) => html`
              <div
                className="aspect-ratio-square lg:w-full h-32 w-32 relative flex-shrink-0"
                onClick="${() => setActiveSlide(index)}"
                key="${index}"
              >
                <div
                  className="flex flex-col justify-center items-center bg-primary-50 aspect-ratio-box-inside text-primary-700 hover:text-primary-500 transition-all duration-300 ease-linear cursor-pointer"
                >
                  <img src="${data.icon}" alt="" />
                  <span className="mt-5 font-semibold text-sm">${data.title}</span>
                </div>
              </div>
            `
          )}
          <div className="absolute bottom-0 h-1 w-full mb-px">
            <div
              className="h-full w-1/8 transition duration-200 ease-in-out"
              style="transform: translateX(${activeSlide * 100}%)"
            >
              <div className="h-full bg-black w-2/3 mx-auto"></div>
            </div>
          </div>
        </div>
        <${CardTemplate}>
          ${mapping[activeSlide].content}
        <//>
      <//>
      <img
        src="${mapping[activeSlide].background}"
        alt=""
        className="absolute inset-0 h-full w-full z-0 object-cover"
      />
    </div>
  `;
};

const EatContent = () => {
  return html`
    <${CardHeading}>Discover delicious eats<//>
    <${CardBody}>Order delivery from restaurants you love.<//>
    <${CardFooter}>
      <button className="button button-flat button-lg button-black flex-shrink-0 mr-3">Order now</button>
      <${UnderlineLink} href="#" className="my-3 xl:mx-auto">
        Own a restaurant? Partner with Uber Eats
      <//>
    <//>
  `;
};

const RideContent = () => {
  return html`
    <${CardHeading}>Request a ride now<//>
    <${CardBody} />
    <${CardFooter}>
      <a href="#" className="button button-flat button-lg button-black mr-5">
        Request now
      </a>
      <a href="#" className="button button-flat button-lg button-light">
        Schedule for later
      </a>
    <//>
  `;
};

const EarnContent = () => {
  return html`
    <${CardHeading}>Get in the driver's seat and get paid<//>
    <${CardBody}>Drive on the platform with the largest network of active riders.<//>
    <${CardFooter}>
      <a href="#" className="button button-flat button-lg button-black flex-shrink-0 mr-3">
        Sign up to drive
      </a>
      <${UnderlineLink} href="#" className="mt-4">
        "Own a restaurant? Partner with Uber Eats"
      <//>
    <//>
  `;
};

const FreightContent = () => {
  return html`
    <${CardHeading}>A new direction for freight<//>
    <${CardBody}>Greater transparency for shippers and carriers to do business together.<//>
    <${CardFooter}>
      <button className="button button-flat button-lg button-black flex-shrink-0 mr-5">Get shipper details</button>
      <${UnderlineLink} href="#" className="my-3">
        Sign up to be a carrier
      <//>
    <//>
  `;
};

const BusinessContent = () => {
  return html`
    <${CardHeading}>Move your teams and employees<//>
    <${CardBody}>Uber for Business helps to simplify business travel, expensing, and customer experiences.<//>
    <${CardFooter}>
      <button className="button button-flat button-lg button-black flex-shrink-0">Learn more</button>
    <//>
  `;
};

const TransitContent = () => {
  return html`
    <${CardHeading}>Empowering public transportation<//>
    <${CardBody}>
      Uber’s software and transit solutions help local agencies build the best ways to move their communities forward.
    <//>
    <${CardFooter}>
      <a href="#" className="button button-flat button-lg button-black flex-shrink-0">
        Learn more
      </a>
    <//>
  `;
};

const BikeContent = () => {
  return html`
    <${CardHeading}>Bike or scoot there<//>
    <${CardBody}>Go farther and have more fun with electric bikes and scooters.<//>
    <${CardFooter}>
      <a href="#" className="button button-flat button-lg button-black flex-shrink-0">
        Get a ride
      </a>
    <//>
  `;
};

const ElevateContent = () => {
  return html`
    <${CardHeading}>Ridesharing at new heights<//>
    <${CardBody}>Building the future of transportation with urban aerial ridesharing.<//>
    <${CardFooter}>
      <a href="#" className="button button-flat button-lg button-black flex-shrink-0">
        Learn more
      </a>
    <//>
  `;
};

const CardTemplate = ({ children }) => {
  return html`<div className="w-full lg:w-1/2 bg-white flex flex-col px-5 md:px-8 py-10 lg:p-10">${children}</div>`;
};

const CardHeading = ({ children }) => {
  return html`<h2 className="text-4xl lg:text-5xl font-semibold">${children}</h2>`;
};

const CardBody = ({ children }) => {
  return html`<p className="py-5">${children}</p>`;
};

const CardFooter = ({ children }) => {
  return html`<div className="flex items-center mt-5 flex-wrap">${children}</div>`;
};
